import { ASSOCIATION_LOGOS } from "@/data/content";
import { ShieldCheck } from "lucide-react";
import { resolveAssetPath } from "@/lib/assets";

export const AssociationsMarquee = () => {
  return (
    <section
      id="memberships"
      data-testid="associations-grid"
      className="relative bg-[var(--navy)] py-16 overflow-hidden"
    >
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#fcd34d]/5 blur-3xl rounded-full pointer-events-none" />

      <div className="relative max-w-[1280px] mx-auto px-4 lg:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-[var(--yellow)] font-semibold text-[11px] tracking-[0.3em] mb-3">
            <ShieldCheck className="w-4 h-4" />
            OUR ASSOCIATIONS & RECOGNITIONS
          </div>
          <h2 className="font-serif-display text-3xl md:text-4xl text-white leading-tight">
            Travel associations & tourism authorities
          </h2>
          <p className="text-white/55 mt-3 text-sm max-w-xl mx-auto">
            Travel industry associations and tourism authorities.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {ASSOCIATION_LOGOS.map((a, i) => (
            <div
              key={a.acronym}
              data-testid={`assoc-logo-${i}`}
              className="group relative bg-white border border-white/10 hover:border-[var(--yellow)] rounded-xl p-4 flex flex-col items-center justify-center text-center min-h-[160px] transition-all duration-300 hover:-translate-y-1"
            >
              {a.type === "image" ? (
                <img
                  src={resolveAssetPath(a.image)}
                  alt={`${a.name} logo`}
                  loading="lazy"
                  className="h-20 max-w-full object-contain mb-2"
                />
              ) : (
                <div className="mb-2 w-12 h-12 rounded-full bg-gradient-to-br from-[var(--yellow)] to-[var(--yellow-2)] flex items-center justify-center shadow-lg shadow-[#fcd34d]/20 group-hover:scale-110 transition-transform">
                  <span className="font-serif-display font-bold text-[var(--navy)] text-[11px] leading-none">
                    {a.acronym.length > 5 ? a.acronym.slice(0, 4) : a.acronym}
                  </span>
                </div>
              )}
              <div className="font-serif-display text-[13px] text-[var(--navy)] leading-tight">
                {a.acronym}
              </div>
              <div className="text-[9px] uppercase tracking-wider text-[#0b2545]/60 mt-1 line-clamp-2">
                {a.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};